import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdoptionagePipe } from './adoptionage.pipe';
import { AdoptionbreedPipe } from './adoptionbreed.pipe';
import { AdoptioncityPipe } from './adoptioncity.pipe';
import { AdoptioncolorPipe } from './adoptioncolor.pipe';
import { AdoptionlocationPipe } from './adoptionlocation.pipe';
import { BrandfilterPipe } from './brandfilter.pipe';
import { FlavourfilterPipe } from './flavourfilter.pipe';
import { BreedfilterPipe } from './breedfilter.pipe';
import { BreedforumPipe } from './breedforum.pipe';
import { CateforyforumPipe } from './cateforyforum.pipe';
import { CheckdayPipe } from './checkday.pipe';
import { DinamicCityPipe } from './dinamiccity.pipe';
import { DynamicbrandPipe } from './dynamicbrand.pipe';
import { DynamicbreedPipe } from './dynamicbreed.pipe';
import { Dynamicbreed22Pipe } from './dynamicbreed22.pipe';
import { DynamicflavourPipe } from './dynamicflavour.pipe';
import { DynamiclifestagePipe } from './dynamiclifestage.pipe';
import { GeolocationdistancePipe } from './geolocationdistance.pipe';
import { LifestageblogPipe } from './lifestageblog.pipe';
import { LifestagefilterPipe } from './lifestagefilter.pipe';
import { LifestageforumPipe } from './lifestageforum.pipe';
import { MyfilterPipe } from './myfilter.pipe';
import { OnlinedocPipe } from './onlinedoc.pipe';
import { ProductnamefilterPipe } from './productnamefilter.pipe';
import { ProductpriceorderPipe } from './productpriceorder.pipe';
import { ProductsearchPipe } from './productsearch.pipe';
import { SearchPipe } from './search.pipe';
import { SpecialPipe } from './special.pipe';
import { UniqleavedatePipe } from './uniqleavedate.pipe';
import { UniquePipefilter } from './uniquefilter.pipe';
import { Uniquefilter2Pipe } from './uniquefilter2.pipe';
import { UniquefilterforumPipe } from './uniquefilterforum.pipe';
import { CategoryfilterPipe } from './categoryfilter.pipe';
import { PettypefilterPipe } from './pettypefilter.pipe';
import { PettypeforumPipe } from './pettypeforum.pipe';

@NgModule({
  imports: [
     CommonModule,
     ],
    declarations: [
        AdoptionagePipe,
        AdoptionbreedPipe,
        AdoptioncityPipe,
        AdoptioncolorPipe,
        AdoptionlocationPipe,
        BrandfilterPipe,
        FlavourfilterPipe,
        BreedfilterPipe,
        BreedforumPipe,
        CateforyforumPipe,
        CheckdayPipe, DinamicCityPipe,
        DynamicbrandPipe,
        DynamicbreedPipe,
        Dynamicbreed22Pipe,
        DynamicflavourPipe,
        DynamiclifestagePipe,
        GeolocationdistancePipe,
        LifestageblogPipe,
        LifestagefilterPipe,
        LifestageforumPipe,
        MyfilterPipe,
        OnlinedocPipe,
        ProductnamefilterPipe,
        ProductpriceorderPipe,
        ProductsearchPipe,
        SearchPipe,
        SpecialPipe,
        UniqleavedatePipe ,
        UniquePipefilter,
        Uniquefilter2Pipe,
        UniquefilterforumPipe ,
        CategoryfilterPipe,
        PettypefilterPipe,PettypeforumPipe
    ],
     entryComponents:
      [],
  providers: [],
  exports: [AdoptionagePipe,AdoptionbreedPipe, AdoptioncityPipe,AdoptioncolorPipe,
    AdoptionlocationPipe,BrandfilterPipe,FlavourfilterPipe,BreedfilterPipe,
    BreedforumPipe,CateforyforumPipe,CategoryfilterPipe,CheckdayPipe, DinamicCityPipe,
    DynamicbrandPipe,DynamicbreedPipe,Dynamicbreed22Pipe,DynamicflavourPipe,DynamiclifestagePipe,
    GeolocationdistancePipe,LifestageblogPipe,LifestagefilterPipe,LifestageforumPipe,
    MyfilterPipe,OnlinedocPipe,PettypefilterPipe,PettypeforumPipe,ProductnamefilterPipe,
    ProductpriceorderPipe, ProductsearchPipe,SearchPipe,SpecialPipe,UniqleavedatePipe ,UniquePipefilter,
    Uniquefilter2Pipe,UniquefilterforumPipe ],
})
export class FilterModule { }